const IMAGES = {
  handbags: "https://images.unsplash.com/photo-1594223274512-ad4803739b7c?crop=entropy&cs=srgb&fm=jpg&q=80",
  watches: "https://images.unsplash.com/photo-1600003014755-ba31aa59c4b6?crop=entropy&cs=srgb&fm=jpg&q=80",
  jewelry: "https://images.unsplash.com/photo-1633934542430-0905ccb5f050?crop=entropy&cs=srgb&fm=jpg&q=80",
  fashion: "https://images.unsplash.com/photo-1613909671501-f9678ffc1d33?crop=entropy&cs=srgb&fm=jpg&q=80",
  footwear: "https://images.unsplash.com/photo-1618677831708-0e7fda3148b4?crop=entropy&cs=srgb&fm=jpg&q=80",
  accessories: "https://images.unsplash.com/photo-1523754865311-b886113bb8de?crop=entropy&cs=srgb&fm=jpg&q=80",
};
const FALLBACK = "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?crop=entropy&cs=srgb&fm=jpg&q=80";

export function categoryImage(slug, w = 1200) {
  const base = IMAGES[(slug || "").toLowerCase()] || FALLBACK;
  return `${base}&auto=format&fit=crop&w=${w}`;
}

export const CATEGORY_BLURB = {
  handbags: "Totes, crossbodies, clutches and weekenders from the houses shoppers love — compared and priced across stores.",
  watches: "Chronographs, automatics and dress watches worth the investment, ranked by our editors.",
  jewelry: "Fine gold, diamond and everyday luxury pieces to gift or treasure.",
  fashion: "Designer dresses, coats, knitwear and blazers — the season's best, curated.",
  footwear: "Designer sneakers, boots, loafers and heels styled for every occasion.",
  accessories: "Sunglasses, wallets, belts and finishing touches that elevate any look.",
};
